import React, { Component } from 'react';

class GroupedLogList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			expanded_keys: [],
			groups: {}
		};

		this.toggleExpanded = this.toggleExpanded.bind(this)
	}

	componentDidMount() {
		let {logs, group_pos} = this.props
		let groups = {}
		Object.keys(logs).forEach((ts) => {
			let vals = logs[ts]
			let group_key = vals[group_pos]
			if (groups[group_key] == null) {
				groups[group_key] = []
			}
			groups[group_key].push(ts)
		})
		this.setState({groups})
	}

	toggleExpanded(key) {
		let {expanded_keys} = this.state
		let idx = expanded_keys.indexOf(key)
		if (idx > -1) {
			expanded_keys.pop(idx)
		} else {
			expanded_keys.push(key)
		}
		this.setState({expanded_keys})
	}

	render() {
		let {groups, expanded_keys} = this.state
		return (
              <ul className="GroupedLogList">{ Object.keys(groups).map((group_key) => {
                let children
                let expanded = expanded_keys.indexOf(group_key) > -1
                if (expanded) {
                	children = (
                		<ul className="GroupLogs">
                			{ groups[group_key].map((ts) => {
                				return <li key={ts}>{ts}</li>
                			})}
                		</ul>
                		)
                }
                let icon = expanded ? <i className="fa fa-arrow-down"></i> : <i className="fa fa-arrow-right"></i>
                return <li key={group_key}><a href="javascript:void(0)" onClick={this.toggleExpanded.bind(this, group_key)}>{ icon } { group_key }</a>{children}</li>
              }) }
              </ul>
        )
	}
}

GroupedLogList.defaultProps = {
	logs: [],
	group_pos: 1
}

export default GroupedLogList